// Account-scoped API client for managing LLM provider tokens.
// Notes:
// - The server never returns raw access tokens, only an indicator (has_token).
// - To set or rotate a token pass { access_token: 'plain-value' } in create/update.
// - provider_name must be one of the supported providers defined server-side.
// - active can be toggled with update calls.
//
// Basic usage examples:
//   llmProviderTokens.get();              // List all tokens
//   llmProviderTokens.create({ provider_name: 'openai', access_token: 'sk-...', active: true });
//   llmProviderTokens.update(id, { active: false });
//   llmProviderTokens.update(id, { access_token: 'new-value' }); // rotates token
//   llmProviderTokens.delete(id);         // Remove a token
//
// Convenience helpers provided:
//   activate(id)   -> sets active: true
//   deactivate(id) -> sets active: false
//
// All methods return Axios promises.
import ApiClient from './ApiClient';

class LlmProviderTokensAPI extends ApiClient {
  constructor() {
    super('llm_provider_tokens', { accountScoped: true });
  }

  create(payload) {
    return super.create({ llm_provider_token: payload });
  }

  update(id, payload) {
    return super.update(id, { llm_provider_token: payload });
  }

  activate(id) {
    return this.update(id, { active: true });
  }

  deactivate(id) {
    return this.update(id, { active: false });
  }

  rotate(id, newPlainToken) {
    return this.update(id, { access_token: newPlainToken });
  }
}

export default new LlmProviderTokensAPI();
